module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/order_01-a7cae52cc6e1cb601ca5a7fd41d49d81.png";